import { log } from '@/api/api'
//import { store } from '@/store/store'
import { isEmpty } from 'lodash-es'
import format from 'date-fns/format'

const excludes = [
  'Request aborted',
  'Request failed with status code 401',
  '{}',
  'Network Error'
]

export const logger = {
  debug: (message) => {
    if (import.meta.env.DEV) {
      const timestamp = format(new Date(), 'kk:mm:ss:SSS')

      if (message instanceof Object) {
        message = JSON.stringify(message)
      }

      console.log(`%c${timestamp} [DEBUG] ${message}`, 'color: green;')
    }
  },
  error: async (message, userId = null) => {
    //console.error(message)
    if (import.meta.env.DEV) {
      console.error(`[ERROR] ${message}`)
    } else {
      // In case of error object extract the message
      if (message && !(message instanceof String)) {
        message = message.message || JSON.stringify(message)
      }

      // Log it to the console as well for now
      //console.error(`[ERROR] ${message}`)

      // Exclude empty and unimportant messages
      if (!isEmpty(message) && !excludes.includes(message)) {
        await log({
          level: 'ERROR',
          message: message,
          user: userId,
          url: window.location.href
        })
      }
    }
  }
}
